import { useTranslation, useLocale } from "@aviv-unified-frontend/runtime/i18n";
import { CDP_I18N_NAMESPACE } from "@/constants";
export const useLoadTranslations = () => {
    const { language } = useLocale();
    const { addTranslations } = useTranslation(CDP_I18N_NAMESPACE);
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const translations = require(`../../../locales/${language}/common.json`);
    addTranslations({ language, translations });
};
